/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TrueGritGameMode} from "../server/TrueGritGameMode";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {IWinRatioConfig, TrueGritWinConfigs} from "../configs/TrueGritWinConfigs";
import {LoopableList} from "../utils/LoopableList";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TrueGrit} from "../TrueGrit";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TrueGritSymbol} from "../reels/TrueGritSymbol";

export class TrueGritSound {

    private static MAIN_GAME_MUSIC:string = "background-music-main";
    private static FS_MUSIC_NAME:string = "background-music-fs";
    private static SUPER_FS_MUSIC_NAME:string = "background-music-super-fs";

    private static REEL_STOP_SOUNDS:LoopableList<string> = new LoopableList(["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6", "reelLanding7", "reelLanding8", "reelLanding9",
        "reelLanding10", "reelLanding11"]).setRandomizeAtWrapAround(true);


    public static AS_WIN:string = "asWin";
    public static AS_WIN_BIG:string = "asWinBig";

    public static CAP_WIN_START:string = "capWinStart";
    public static CAP_WIN_MUSIC:string = "capWinMusic";
    public static CAP_WIN_CONTINUE:string = "capWinContinue";

    public static TRAIN_REEL_START:string = "trainReelsOnStart";
    public static TRAIN_REEL_START_FAST:string = "trainReelsOnStartFast";
    public static TRAIN_REEL_IN:string = "trainReelsIn";
    public static TRAIN_REEL_IN_FAST:string = "trainReelsInFast";
    public static TRAIN_REEL_STOP_SOUND:string = "trainReelsLanding";
    public static TRAIN_REEL_BOX_BREAK_SOUND:string = "trainReelBotBoxBreak";

    public static X_NUDGE_SOUNDS:LoopableList<string> = new LoopableList(["xNudge1", "xNudge2"]).setRandomizeAtWrapAround(true);
    public static X_NUDGE_RESET:string = "xNudgeReset";
    public static X_NUDGE_NO_WIN:string = "xNudgeNoWin";
    public static REEL_SPLIT_SOUND:string = "reelSplit";

    public static TRANSFORM_LOW_SOUND:string = "transformLow";
    public static TRANSFORM_LOW_ALL_SOUND:string = "transformLowAll";

    public static TRANSFORM_HIGH_SOUND:string = "transformHigh";
    public static TRANSFORM_HIGH_ALL_SOUND:string = "transformHighAll";
    public static TRANSFORM_ALL_HIGH_SOUND:string = "transformHighAllWin";
    public static TRANSFORM_ALL_LOW_SOUND:string = "transformLowAllWin";

    public static WILD_TRANSFORM_SOUND:string = "midSymsToWild";
    public static WILD_TRANSFORM_NO_WIN_SOUND:string = "midSymsToWildNoWin";
    public static SCATTER_LANDED_SOUND:string = "scatterLanding";
    public static SCATTER_4_LANDED_SOUND:string = "scatter4Landing";
    public static SCATTER_SPIN_BACK_SOUND:string = "scatterSpinBack";
    public static SCATTER_SPLIT:string = "scatterSplit";
    public static SCATTER_SPLIT_2:string = "scatterSplit2";
    public static SCATTER_PLUS_SPINS:string = "plusSpin";

    private static BOX_EXPLOSION_SOUNDS:LoopableList<string> = new LoopableList(["gunBox1", "gunBox2", "gunBox3", "gunBox4", "gunBox5", "gunBox6"]).setRandomizeAtWrapAround(true);

    public static GUN_BOX_WILD_SOUND_1:string = "gunBoxWild1";
    public static GUN_BOX_WILD_SOUND_2:string = "gunBoxWild2";
    public static GUN_BOX_WILD_SOUND_3:string = "gunBoxWild3";
    public static GUN_BOX_WILD_SOUND_4:string = "gunBoxWild4";


    public static COUNT_UP:string = "countup";
    public static COUNT_UP_END_TINY:string = "countupEndsTiny";
    public static COUNT_UP_END_SMALL:string = "countupEndsSmall";
    public static COUNT_UP_END_MEDIUM:string = "countupEndsMedium";
    public static COUNT_UP_END_LARGE:string = "countupEndsLarge";
    public static COUNT_UP_END_FS:string = "countupEndsFS";

    public static FS_INTRO_MUSIC_NAME:string = "background-music-fs-intro";
    public static FS_INTRO_START:string = "fsIntroStart";
    public static FS_NORMAL_START:string = "fsNormalStart";
    public static FS_SUPER_NORMAL_START:string = "fsSuperStart";

    public static FS_OUTRO_LOW_WIN:string = "fsNormalOutroLowWin";
    public static FS_OUTRO_HIGH_WIN:string = "fsNormalOutroHighWin";

    public static SUPER_FS_OUTRO_LOW_WIN:string = "fsSuperOutroLowWin";
    public static SUPER_FS_OUTRO_HIGH_WIN:string = "fsSuperOutroHighWin";

    public static OUTRO_BUTTON:string = "fsOutroContinue";


    public static BIG_WIN_LEVEL_PREFIX:string = "bigwinLevel";
    public static BIG_WIN_ENDS:string = "bigwinEnds";


    public static GUN_BET_LINE_M0:string = "gunBetlineM0";
    public static GUN_BET_LINE_XL:string = "gunBetlineXL";
    public static GUN_BET_LINE_XL_WILD:string = "gunBetlineXLWild";

    // #310
    public static ANTICIPATION: string = "anticipation";
    public static ANTICIPATION_ADD_ON: string = "anticipationAddon";
    public static ANTICIPATION_FAIL: string = "anticipationFail";
    public static ANTICIPATION_FAIL_ADD_ON: string = "anticipationFailAddon";
    public static GRIT_GIRL_1: string = "gritGirl1";
    public static GRIT_GIRL_2: string = "gritGirl2";
    public static GRIT_GIRL_WIN: string = "gritGirlWin";

    // #420
    public static GRIT_GIRL_SHAKE_1: string = "gritGirlShake1";
    public static GRIT_GIRL_SHAKE_2: string = "gritGirlShake2";
    public static GRIT_GIRL_SHAKE_3: string = "gritGirlShake3";

    public  static XWAYS_LANDING:string = "xWaysLanding";
    public  static XWAYS_REVEAL_LOW:string = "xWaysRevealLow";
    public  static XWAYS_REVEAL_MID:string = "xWaysRevealMid";
    public  static XWAYS_INFECTIOUS_REVEAL:string = "xWaysInfectiousReveal";
    public  static XWAYS_INFECTIOUS_SPLIT_LOW:string = "xWaysInfectiousSplitLow";
    public  static XWAYS_INFECTIOUS_SPLIT_MID:string = "xWaysInfectiousSplitMid";

    public static GUN_BET_LINE_TINY:LoopableList<string> = new LoopableList<string>([
        "gunBetlineTiny1",
        "gunBetlineTiny2",
        "gunBetlineTiny3"
    ]).setRandomizeAtWrapAround(true);

    public static GUN_BET_LINE_SMALL:LoopableList<string> = new LoopableList<string>([
        "gunBetlineSmall1",
        "gunBetlineSmall2",
        "gunBetlineSmall3"
    ]).setRandomizeAtWrapAround(true);

    public static GUN_BET_LINE_LARGE:LoopableList<string> = new LoopableList<string>([
        "gunBetlineLarge1",
        "gunBetlineLarge2"
    ]);



    private player:NolimitAudioPlayer;
    private _currentMusic:string = "";
    private _countUpSound:NolimitHowl | undefined;


    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
    }

    public switchMusic(mode:TrueGritGameMode) {
        let nextMusic = "";

        switch (mode) {
            case TrueGritSound.FS_INTRO_MUSIC_NAME:
                nextMusic = TrueGritSound.FS_INTRO_MUSIC_NAME;
                break;
            case TrueGritGameMode.FREESPIN:
                nextMusic = TrueGritSound.FS_MUSIC_NAME;
                break;
            case TrueGritGameMode.FREESPIN_AVALANCHE:
                nextMusic = TrueGritSound.FS_MUSIC_NAME;
                break;
            case TrueGritGameMode.FREESPIN_SUPER:
                nextMusic = TrueGritSound.SUPER_FS_MUSIC_NAME;
                break;
            case TrueGritGameMode.FREESPIN_SUPER_AVALANCHE:
                nextMusic = TrueGritSound.SUPER_FS_MUSIC_NAME;
                break;
            case TrueGritGameMode.NORMAL_AVALANCHE:
                nextMusic = TrueGritSound.MAIN_GAME_MUSIC;
                break;
            default:
                nextMusic = TrueGritSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        this.player.stopTrack(this._currentMusic);

        this.player.playTrack({name:nextMusic});
        this._currentMusic = nextMusic;
    }

    public fadeMusic(from:number, to:number, duration:number) {
        if (this._currentMusic != "") {
            const currentMusicHowl = this.player.fetchSoundPlayer(this._currentMusic);
            if (currentMusicHowl){
                currentMusicHowl.fade(from, to, duration);
            } else {
                Logger.warn("Music not found for fading.");
            }
        }
    }

    public playSound(name:string, volume?:number, repeat?:number):NolimitHowl | undefined {
        return this.player.playTrack({name:name, volume:volume, repeat:repeat});
    }

    public stopSound(name:string):NolimitHowl | undefined {
        return this.player.stopTrack(name);
    }

    public startCountUp() {
         this._countUpSound = this.playSound(TrueGritSound.COUNT_UP);
         if (this._countUpSound) {
             this._countUpSound.setLoop(true);
         }
    }

    public stopCountUp(config?:IWinRatioConfig, playEndSound:boolean = true) {
        if (this._countUpSound && this._countUpSound.isPlaying) {
            this._countUpSound.stop();
        }

        if (playEndSound){
            let sound = TrueGritSound.COUNT_UP_END_LARGE;

            if (config){
                if (config.type == TrueGritWinConfigs.TINY) {
                    sound = TrueGritSound.COUNT_UP_END_TINY;
                }
                else if (config.type == TrueGritWinConfigs.SMALL) {
                    sound = TrueGritSound.COUNT_UP_END_SMALL;
                }
                else if (config.type == TrueGritWinConfigs.MEDIUM) {
                    sound = TrueGritSound.COUNT_UP_END_MEDIUM;
                }
                else if (config.type == TrueGritWinConfigs.BIG_WIN_06) {
                    sound = "";
                }
            }

            this.playSound(sound);
        }
    }

    public playRandomReelStopSound():void {
        this.playSound(TrueGritSound.REEL_STOP_SOUNDS.next());
    }

    public playRandomBoxExplosionSound():void {
        TrueGrit.muzzleFlashView.playScreenAnimation(0);
        this.playSound(TrueGritSound.BOX_EXPLOSION_SOUNDS.next());
    }


    public playTrainReelStartSound():void {
        if (TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false)){
            this.playSound(TrueGritSound.TRAIN_REEL_START_FAST);
        } else {
            this.playSound(TrueGritSound.TRAIN_REEL_START);
        }
    }
    public playTrainReelInSound():void {
        if (TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false)){
            this.playSound(TrueGritSound.TRAIN_REEL_IN_FAST);
        } else {
            this.playSound(TrueGritSound.TRAIN_REEL_IN);
        }
    }

    public playTrainReelStopSound():void {
        this.playSound(TrueGritSound.TRAIN_REEL_STOP_SOUND);
    }

    public playInitialWinSound(symCount:number, longestLine:number, hitWild:boolean = false, m0Hit:boolean = false) {
        if (m0Hit){
            TrueGrit.muzzleFlashView.playScreenAnimation(0.5);
            this.playSound(TrueGritSound.GUN_BET_LINE_M0);
            return;
        }

        if (longestLine >= 6){
            TrueGrit.muzzleFlashView.playScreenAnimation(0.5);
            if (hitWild){
                this.playSound(TrueGritSound.GUN_BET_LINE_XL_WILD);
            } else {
                this.playSound(TrueGritSound.GUN_BET_LINE_XL);
            }
            return;
        }

        if (symCount > 13) {
            TrueGrit.muzzleFlashView.playScreenAnimation(0.5);
            this.playSound(TrueGritSound.GUN_BET_LINE_LARGE.next());
        } else {
            if (symCount >= 6){
                TrueGrit.muzzleFlashView.playScreenAnimation(0.5);
                this.playSound(TrueGritSound.GUN_BET_LINE_SMALL.next());
            }
            else {
                this.playSound(TrueGritSound.GUN_BET_LINE_TINY.next());
            }
        }

    }

    playInfectiousSplit(lowWin:boolean) {
        if (lowWin){
            this.playSound(TrueGritSound.XWAYS_INFECTIOUS_SPLIT_LOW);
        }else {
            this.playSound(TrueGritSound.XWAYS_INFECTIOUS_SPLIT_MID);
        }
    }

    playXWaySplit(lowWin:boolean) {
        if (lowWin){
            this.playSound(TrueGritSound.XWAYS_REVEAL_LOW);
        }else {
            this.playSound(TrueGritSound.XWAYS_REVEAL_MID);
        }
    }
}